import React from 'react';
import TradesList from '../components/TradesList';

const ListTrades = () => (
  <>
    <TradesList />
  </>
);

export default ListTrades;
